import React, { Component } from "react";

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import classes from "./Loader.scss";

class Loader extends Component {
  state = {
    counter: 0
  };

  componentWillMount() {
    this.myInterval = setInterval(() => {
      this.setState(
        {
          counter: this.state.counter + 1
        },
        () => {
          if (this.state.counter > 4) {
            this.setState({
              counter: 0
            });
          }
        }
      );
    }, 3500);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  FirstChild = (props) => {
    const childrenArray = React.Children.toArray(props.children);
    return childrenArray[0] || null;
  }
  

  render() {
    let loaderTextOne = (
        <h1 className={`u-fontWeightLight u-fontSize28 u-textColorDark u-width100Percent`} key='1'>{ this.props.type === 'flight' ? 'Parking the Plane' : 'Arranging the sheets and blankets'}</h1>  
      );
    let loaderTextTwo = (
      <h1 className={`u-fontWeightLight u-fontSize28 u-textColorDark u-width100Percent`} key='2'>{ this.props.type === 'flight' ? 'Stocking up the Food' : 'Cooking delicious food'}</h1>
    );
    let loaderTextThree = (
      <h1 className={`u-fontWeightLight u-fontSize28 u-textColorDark u-width100Percent`} key='3'>{ this.props.type === 'flight' ? 'Loading the Cargo' : 'Turning on the lights'}</h1>
      );
    let loaderTextFour = (
      <h1 className={`u-fontWeightLight u-fontSize28 u-textColorDark u-width100Percent`} key='4'>{ this.props.type === 'flight' ? 'Refueling the Plane' : 'Turning on air conditioner'}</h1>
    );
    let loaderTextFive = (
        <h1 className={`u-fontWeightLight u-fontSize28 u-textColorDark u-width100Percent`} key='5'>{ this.props.type === 'flight' ? 'Boarding the Plane' : 'Preparing Coffee'}</h1>
    );

    return (
      <div className={classes.Loader}>
        <ReactCSSTransitionGroup 
                  component='div'
                  transitionName='loader'
                  transitionAppear={true}
                  transitionEnter={true}
                  transitionLeave={false}
                  transitionEnterTimeout={3400}
                  transitionAppearTimeout={3400}
                  >
              {this.state.counter === 0
                ? loaderTextOne
                : this.state.counter === 1
                  ? loaderTextTwo
                  : this.state.counter === 2
                    ? loaderTextThree
                    : this.state.counter === 3
                      ? loaderTextFour
                      : this.state.counter === 4
                        ? loaderTextFive
                        : null}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/UI/Loader/Loader.js